<script>
import propsTag from '@/js/util/props/propsTag'

export default {
  props: {
    ...propsTag,
  },
  render(createElement) {
    return createElement(this.tag, this.$slots.default)
  },
}
</script>

<style
  scoped
  lang="scss"
>
div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
video {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: -1;
  display: block;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%)
}
</style>



// WEBPACK FOOTER //
// src/js/components/SilentVideo.vue